module.exports = __webpack_public_path__ + "static/floor--wood@3x.19980ef7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/floor--wood@3x.png
// module id = 200
// module chunks = 126511778744290 246490542736498